import React from 'react';
import { useField } from '@tanstack/react-form';
import type { FieldApi } from '@tanstack/react-form';
import { useTranslation } from 'react-i18next';
import { on } from 'events';

interface FormInputProps {
  form: any;
  name: string;
  label?: string | React.ReactNode;
  subLabel?: string | React.ReactNode;
  placeholder?: string;
  type?: 'text' | 'email' | 'password' | 'number';
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

export const FormInput: React.FC<FormInputProps> = ({
  form,
  name,
  label,
  subLabel,
  placeholder,
  type = 'text',
  required = false,
  disabled = false,
  className = '',
}) => {
  const { t } = useTranslation();
  return (
    <form.Field
      name={name}
      validators={{
        onBlur: ({ value, meta }: any) => {
          if (required && (!value || value.toString().trim() === '')) {
            return 'This field is required';
          }
          return undefined;
        },
        onSubmit: ({ value }: any) => {
          if (required && (!value || value.toString().trim() === '')) {
            return 'This field is required';
          }
          return undefined;
        }
      }}
      children={(field: FieldApi<any, any, any, any, any, any, any, any, any, any, any, any, any, any, any, any, any, any, any, any, any, any, any>) => {
        const hasError = field.state.meta.errors?.length > 0;
        const errorMessage = field.state.meta.errors?.[0];

        return (
          <div
            className={`${
              hasError ? 'form-element error' : 'form-element'
            } ${className}`}
          >
            {label && (
              <label htmlFor={name}>
                {label}
                {required ? '*' : ''}
                {subLabel ? (
                  <span className="sub-label"> {subLabel}</span>
                ) : null}
              </label>
            )}
            <input
              id={name}
              name={name}
              type={type}
              value={field.state.value || ''}
              onChange={(e) => field.handleChange(e.target.value)}
              onBlur={field.handleBlur}
              placeholder={placeholder}
              required={required}
              disabled={disabled}
              className=""
            />
            {hasError && <div className="error-message">{t(errorMessage)}</div>}
          </div>
        );
      }}
    />
  );
};